import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import '../styles.css';

const tvr = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Nao', label: 'Não' },
];

const modificacaotvr = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Nao', label: 'Não' },
];

const dano = [
    { value: 'baixo', label: 'Baixo' },
    { value: 'medio', label: 'Médio' },
    { value: 'alto', label: 'Alto' },
];

export default function Barragem(props) {
    const handleChange = (event) => {
        props.setValues({
            ...props.values,
            [event.target.id]: event.target.value,
        });
    };

    return (
        <>
            <div className="titles">Caracterização da Barragem</div>
            <div className="subtitle">Informações Básicas</div>
            <div className="fundo">
                <div className="rowForm">
                    <div className="auto02">
                        <TextField
                            id="extravasor"
                            label="Tipo de Extravasor"
                            onChange={handleChange}
                            value={props.values.extravasor}
                            margin="dense"
                        />
                    </div>

                    <div className="auto02">
                        <TextField
                            margin="dense"
                            id="tipo"
                            label="Tipo de Barragem"
                            value={props.values.tipo}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto02">
                        <TextField
                            margin="dense"
                            id="altura"
                            type="number"
                            label="Altura Máxima (m)"
                            value={props.values.altura}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto02">
                        <TextField
                            margin="dense"
                            id="comprimento"
                            type="number"
                            label="Comprimento Total do Barramento (m)"
                            value={props.values.comprimento}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className="subtitle">Informações Hidrológicas</div>
            <div className="fundo">
                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="restricao"
                            label="Vazão de Restrição Hidrológica (m³/s)"
                            value={props.values.restricao}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="projeto"
                            type="number"
                            label="Vazão de Projeto do Extravasor (m³/s)"
                            value={props.values.projeto}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="volume"
                            type="number"
                            label="Volume Total do Reservatório (m³)"
                            value={props.values.volume}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="area"
                            type="number"
                            label="Área do Reservatório (km²)"
                            value={props.values.area}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="namaxH"
                            type="number"
                            label="NA Máximo Observado (histórico)"
                            value={props.values.namaxH}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="naminH"
                            type="number"
                            label="NA Mínimo Observado (histórico)"
                            value={props.values.naminH}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>

            <div className="subtitle">Outras Informações</div>
            <div className="fundo">
                <div className="rowForm">
                    <div className="auto4">
                        <TextField
                            id="onda"
                            label="Tempo de Chegada da Onda"
                            onChange={handleChange}
                            value={props.values.onda}
                        />
                    </div>

                    <div className="auto4">
                        <TextField
                            select
                            id="tvr"
                            size="small"
                            label="Possui TVR?"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.tvr}
                            SelectProps={{ native: true }}
                        >
                            {tvr.map((option) => (
                                <option key={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>

                    <div className="auto4">
                        <TextField
                            select
                            id="modificacaotvr"
                            size="small"
                            label="Há edificações afetadas no TVR?"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.modificacaotvr}
                            SelectProps={{ native: true }}
                        >
                            {modificacaotvr.map((option) => (
                                <option key={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>


                    <div className="auto4">
                        <TextField
                            select
                            id="dano"
                            size="small"
                            label="Dano Potencial"
                            variant="outlined"
                            onChange={handleChange}
                            value={props.values.dano}
                            SelectProps={{ native: true }}
                        >
                            {dano.map((option) => (
                                <option key={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </TextField>
                    </div>
                </div>

                <div className="rowForm">
                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="cotaconcreto"
                            label="Cota da Barragem de Concreto"
                            value={props.values.cotaconcreto}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="cotaterra"
                            label="Cota da Barragem de Terra"
                            value={props.values.cotaterra}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="auto6">
                        <TextField
                            margin="dense"
                            id="nivel_restricao"
                            label="Nível de Restrição Estrutural"
                            value={props.values.nivel_restricao}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

Barragem.propTypes = {
    update: PropTypes.bool,
    values: PropTypes.object,
    setValues: PropTypes.func
};
